import script from "./ClinicalSidebar.vue?vue&type=script&setup=true&lang=js"
export * from "./ClinicalSidebar.vue?vue&type=script&setup=true&lang=js"

import "./ClinicalSidebar.vue?vue&type=style&index=0&id=0b1c9daa&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0b1c9daa"]])

export default __exports__